module.exports = __webpack_public_path__ + "static/media/rack_docs.883ace82.md";


//////////////////
// WEBPACK FOOTER
// ./src/examples/rack/rack_docs.md
// module id = 1010
// module chunks = 0